import Background from '../../atoms/images/sliderBackground';
import Container from '../../atoms/container/sliderBackgroundContainer';
import Direction from '../../../../shared/types/enums/direction';
import Focus from '../../../../shared/types/enums/focus';
import List from '../../sections/list/automatedList/automatedList';
import MainContext from '../../../../shared/components/utils/context/mainContext';
import Mask from '../../atoms/mask/sliderMask';
import Pagination from '../pagination/paginationDots';
import SelectorContainer from '../../atoms/container/sliderBackgroundSelectorContainer';
import useImagePreload from '../../../../shared/components/utils/hooks/useImagePreload';
import { store } from '../../../../shared/store/store';
import { useContext, useEffect, useMemo, useState } from 'react';

const TRANSITION_DURATION = 0.5; // 0.5s
const TRANSITION_INTERVAL = 8 * 1000; // 8 seconds

function SliderBackground({
  onSetBackgroundIndex,
}: {
  onSetBackgroundIndex: (index: number) => void;
}) {
  const { display, sliders } = useContext(MainContext);
  const [index, setIndex] = useState(0);
  const data = useMemo(() => sliders?.map((item) => item.sliderImg), [sliders]);
  const images = useImagePreload(data);

  useEffect(() => {
    // Return if no images fetched or not displaying
    if (!images?.length) return;
    if (!display?.background) return;

    // Update background from time to time and focus displayed slider
    const interval = setInterval(() => {
      const { focus } = store.getState();
      if ([Focus.ADS, Focus.SPLASH].includes(focus.focus as number)) {
        return;
      }
      setIndex((prev) => {
        return images?.length ? (prev + 1) % images.length : prev;
      });
    }, TRANSITION_INTERVAL);

    return () => {
      clearInterval(interval);
    };
  }, [display?.background, images]);

  return images?.length ? (
    <Container animation={'slider-opacity'} elOpacity={display?.background}>
      <Mask />
      <List
        onSetBackgroundIndex={onSetBackgroundIndex}
        direction={Direction.HORIZONTAL}
        duration={TRANSITION_DURATION}
        index={index}
        offset={1920}
      >
        {images.map((item, index) => {
          return <Background key={index} src={item?.src} />;
        })}
      </List>
      <Pagination Container={SelectorContainer} index={index} list={images} />
    </Container>
  ) : null;
}

export default SliderBackground;
